import { GridCellProps } from "@progress/kendo-react-grid";

export const ZeroEmptyString = (props: GridCellProps) => {
  return (
    <td
      aria-colindex={props.columnIndex}
      role="gridcell"
    >
      {props.dataItem[props.field!] || ""}
    </td>
  );
};